/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-27 00:00:00
 *
 *******************************************************/
import _ from 'lodash';
// import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  // Page,
  Button,
  ButtonGroup,
  // Layout,
  Card,
  // Badge,
  // Stack,
  // Icon,
  // Link,
  // Tooltip,
  // LegacyCard,
  // TextStyle,
  Tabs
} from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { v4 } from 'uuid';
import * as sass from 'sass';
import { Field, getFormValues, reduxForm, change } from 'redux-form';
import { templateRender, templateBuilder, formatTemplate } from 'boost-template-engine';

import * as templateInstanceAction from 'actions/shopify-integration/template-instance-actions';
import { getShop } from 'src/helpers';
import { combineWidgets, detectLoops, bytesToMB, calculateDocSize } from 'src/helpers/ssr-helper';
import { routes } from 'src/routes';
import * as themeIntegrationAction from 'actions/shopify-integration/theme-integration-actions';
import { handleOpenFullscreen } from 'actions/app-integration-actions';
import {
  enterSABFullscreen,
  exitSABFullscreen
} from 'src/integrations/shopify-app-bridge/fullscreen';
import { FullscreenBar } from 'src/components/views/common/fullscreenBar';
import SettingsHeading from './settings-heading';
import { CodeEditor } from './code-editor';
import { waitFor } from 'src/helpers/time-helper';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';

class SsrCodeEditor extends Component {
  state = {
    templateId: '',
    themeId: '',
    settings: {},
    selectedWidget: [],
    codeEditTemplate: {},
    selectedTabIndex: 0,
    widgetSettings: {},
    previewData: {},
    // compiledTemplate: {},
    previewHtml: '',
    originalCompiledSizes: 0,
    originalRenderedSizes: 0,
    initializedPreview: false,
    compiledSettingsCss: '',
    originalTemplate: '',
    customizeTemplate: ''
  };

  componentDidMount() {
    const { getTemplateInstance, getThemeSettings, updateField } = this.props;
    const { templateId } = this.props.match.params;
    this.handleOpenFullscreenPage();
    updateField('enableCustomization', false);
    this.setState({ templateId });
    getTemplateInstance(templateId);
    getThemeSettings(templateId);
  }

  componentWillReceiveProps(nextProps) {
    const { codeEditTemplate, initializedPreview } = this.state;
    const { formValues, widgetSettings } = this.props;
    const {
      instantWidget,
      widgetSettings: nextWidgetSettings,
      formValues: nextFormValues,
      scssContent: nextScssContent
    } = nextProps;

    // first time compile scss from scss content and widget settings
    if (
      !_.isEmpty(nextWidgetSettings) &&
      !_.isEmpty(nextScssContent) &&
      _.isEmpty(this.state.compiledSettingsCss)
    ) {
      this.compileScss(nextWidgetSettings, nextScssContent);
    }
    // get selected widget from instance template
    if (
      !_.isEmpty(instantWidget) &&
      !_.isEmpty(instantWidget.widgets) &&
      _.isEmpty(this.state.selectedWidget)
    ) {
      const mainWidgetId = instantWidget.widgetIds?.collectionFilters;
      console.log('instantWidget', mainWidgetId, instantWidget.widgetIds?.collectionFilters);

      const selectedWidget =
        instantWidget.widgets[mainWidgetId] || Object.values(instantWidget.widgets)[0];
      console.log('selectedWidget', selectedWidget);

      this.setState({
        selectedWidget,
        originalTemplate: selectedWidget
      });
    }
    // init widgetSettings state
    if (_.difference(nextWidgetSettings, this.state.widgetSettings)) {
      this.setState({ widgetSettings });
    }
    // update customization flags from formvalue to selected editing widget-template
    if (
      !_.isEmpty(nextFormValues) &&
      formValues?.enableCustomization !== nextFormValues.enableCustomization
    ) {
      codeEditTemplate.hasCustomized = nextFormValues.enableCustomization;
      this.setState({ codeEditTemplate });
    }

    // init preview when settings & instance template ready
    if (!initializedPreview && !_.isEmpty(widgetSettings) && !_.isEmpty(instantWidget)) {
      this.setState({ initializedPreview: true });
      this.getPreviewData();
    }
  }

  compileScss = async (widgetSettings, scssContent) => {
    if (!_.isEmpty(widgetSettings) && !_.isEmpty(scssContent)) {
      const sassMapString = `$settings: (${this.drill(widgetSettings)});\n`;
      const compiledScss = sassMapString + '\n' + scssContent;
      const { css } = sass.compileString(compiledScss);

      this.setState({ compiledSettingsCss: css });
      // console.log('compiledSettingsCss', css);
      await waitFor(500);
      this.compileMainTemplate();
    }
  };

  handleOpenFullscreenPage = () => {
    const { handleOpenFullscreen } = this.props;
    enterSABFullscreen();
    handleOpenFullscreen(true);
  };

  // Handle action closing the fullscreen
  handleCloseFullscreenPage = () => {
    const { handleOpenFullscreen } = this.props;
    this.backToManagementPage();
    exitSABFullscreen();
    handleOpenFullscreen(false);
  };

  backToManagementPage = () => {
    const { history } = this.props;
    history.push(routes.shopifyIntegration.view());
  };

  updateCurrentSection = async template => {
    console.log('updateCurrentSection', template);
    const { widgetSettings } = this.state;
    const { updateField } = this.props;
    const { hasCustomized = false } = template;
    const customizeTemplate = !_.isEmpty(template.customizeTemplate)
      ? template.customizeTemplate
      : formatTemplate(templateBuilder(template.widgetTemplate, widgetSettings, {}, true));
    // template.customizeTemplate = customizeTemplate;
    // template.hasCustomized = hasCustomized;
    this.setState({ codeEditTemplate: template, selectedTabIndex: 0, customizeTemplate });
    await waitFor(100);
    updateField('enableCustomization', hasCustomized);
  };

  handleTabChange = selectedTabIndex => {
    const { codeEditTemplate, widgetSettings } = this.state;
    if (selectedTabIndex === 0) {
      const customizeTemplate = !_.isEmpty(codeEditTemplate.customizeTemplate)
        ? codeEditTemplate.customizeTemplate
        : formatTemplate(
            templateBuilder(codeEditTemplate.widgetTemplate, widgetSettings, {}, true)
          );
      this.setState({ customizeTemplate });
    }
    this.setState({ selectedTabIndex });
  };

  getRequestParams = () => {
    return {
      t: Date.now(),
      sid: v4(),
      _: 'pf',
      shop: getShop(),
      page: 1,
      limit: 16,
      sort: 'Relevance',
      locale: 'en',
      event_type: 'init',
      build_filter_tree: true,
      pg: 'collection_page',
      handle: 'all',
      viewAs: 'grid--3',
      previewMode: true
    };
  };
  getPreviewData = async () => {
    const host = process.env.REACT_APP_FILTER_URL || 'https://staging.bc-solutions.net';
    const filterUrl = host + '/bc-sf-filter/filter';
    const params = this.getRequestParams();
    const response = await fetch(`${filterUrl}?${new URLSearchParams(params)}`, { method: 'GET' });
    const previewData = await response.json();
    this.setState({ previewData });
    this.compileMainTemplate();
  };

  /**
   * compile & render preview template
   */
  compileMainTemplate = async () => {
    console.log('compileMainTemplate');
    const {
      selectedWidget,
      previewData,
      widgetSettings,
      compiledSettingsCss,
      originalRenderedSizes,
      originalCompiledSizes
    } = this.state;
    if (
      !_.isEmpty(selectedWidget) &&
      !_.isEmpty(widgetSettings) &&
      !_.isEmpty(compiledSettingsCss) &&
      !_.isEmpty(previewData)
    ) {
      const compiledTemplate = await combineWidgets(
        'Filter tree and Product listing',
        selectedWidget,
        widgetSettings,
        compiledSettingsCss
      );
      // console.log('compiledTemplate', compiledTemplate); originalRenderedSizes
      const renderedTemplate = templateRender(compiledTemplate, {
        ...previewData,
        request: this.getRequestParams()
      });
      waitFor(100);
      this.setState({
        previewHtml: renderedTemplate
      });
      // set origin render size
      if (!originalRenderedSizes || originalRenderedSizes === 0) {
        this.setState({
          originalRenderedSizes: calculateDocSize(renderedTemplate)
        });
      }
      // set origin doc size
      if (!originalCompiledSizes || originalCompiledSizes === 0) {
        this.setState({
          originalCompiledSizes: calculateDocSize(compiledTemplate)
        });
      }
    }
  };

  onChangeCode = async value => {
    const {
      widgetSettings,
      codeEditTemplate,
      previewData,
      selectedWidget,
      compiledSettingsCss,
      originalRenderedSizes,
      originalCompiledSizes
    } = this.state;
    const verifyCode = async value => {
      try {
        const detectLoop = detectLoops(value);
        console.log('detectLoop', detectLoop);
        const memoryBefore = window.performance.memory.usedJSHeapSize || 0;
        console.time('verifyCodeCustomization');
        const cloneSelectedWidget = _.cloneDeep(selectedWidget);
        const updatedTemplate =
          cloneSelectedWidget.find(widget => widget?.widgetName === codeEditTemplate?.widgetName) ||
          {};
        updatedTemplate.hasCustomized = true;
        updatedTemplate.customizeTemplate = value;

        // Start calculate performance usage for compile and render customizations
        await waitFor(200); // wait for fresh memory usage by react and another script
        const startCompileTime = new Date();
        // calculate compile template
        const compiledTemplate = await combineWidgets(
          'Filter tree and Product listing',
          cloneSelectedWidget,
          widgetSettings,
          compiledSettingsCss
        );
        const memoryAfterCompile = window.performance.memory.usedJSHeapSize || 0;
        const endCompileTime = new Date();
        const verifyRendered = templateRender(compiledTemplate, {
          ...previewData,
          request: this.getRequestParams()
        });
        const compiledSize = calculateDocSize(compiledTemplate);
        const customizationRenderedSize = calculateDocSize(verifyRendered);

        // log customization calculations info
        const endRenderTime = new Date();
        const timeCompileDiff = endCompileTime - startCompileTime;
        const timeRenderDiff = endRenderTime - endCompileTime;

        const memoryAfterRender = window.performance.memory.usedJSHeapSize || 0;

        const memoryCompileDiff = memoryAfterCompile - memoryBefore;
        const memoryRenderDiff = memoryAfterRender - memoryAfterCompile;

        console.log(`Template size: 
          - Original compile size: ${bytesToMB(originalCompiledSizes)} MB
          - Customization compile size: ${bytesToMB(compiledSize)} MB
          - Original render size: ${bytesToMB(originalRenderedSizes)} MB
          - Customization size ${bytesToMB(customizationRenderedSize)} MB`);

        console.log(`Customization Template Memory 
        - Before compile and render: ${memoryBefore} bytes, 
        - After compile:  ${memoryAfterCompile} bytes
        - After render:  ${memoryAfterRender} bytes`);
        console.log(`Memory used: 
          - Compile ${bytesToMB(memoryCompileDiff)} MB
          - Render ${bytesToMB(memoryRenderDiff)} MB`);
        console.log(`Time compile and render customization:
          - Compile: ${timeCompileDiff.toFixed(2)} milliseconds
          - Render: ${timeRenderDiff.toFixed(2)} milliseconds
          `);
        console.timeEnd('verifyCodeCustomization');
        // console.log(`template builded: ${verifyBuilded}`);
        // console.log(`template rendered: ${verifyRendered}`);
        return true;
      } catch (e) {
        return false;
      }
    };
    const compiledTemplate = verifyCode(value);
    if (compiledTemplate) {
      codeEditTemplate.customizeTemplate = value;
      codeEditTemplate.hasCustomized = true;
      this.setState({ compiledTemplate });
      await waitFor(300);
      this.compileMainTemplate();
    }
  };

  onChangeSettings = async value => {
    const { selectedWidget, widgetSettings } = this.state;
    const { scssContent } = this.props;
    const verifySettings = await combineWidgets(
      'Filter tree and Product listing',
      selectedWidget,
      widgetSettings
    );
    const updateSettings = JSON.parse(value);
    if (!_.isEmpty(verifySettings)) {
      this.setState({ widgetSettings: JSON.parse(value) });
      this.compileMainTemplate();
      this.compileScss(updateSettings, scssContent);
    }
  };

  drill = obj => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const buildValue = value => {
        if (!value) return `'${key}': inherit,`;
        if (value && typeof value === 'object') return `'${key}': (${this.drill(value)}),`;
        return `'${key}': ${JSON.stringify(String(value))},`;
      };
      acc += buildValue(value);
      return acc;
    }, '');
  };

  render() {
    const { i18n, formValues, updateTemplateInstancesLoading } = this.props;
    const {
      selectedWidget,
      selectedTabIndex,
      codeEditTemplate,
      widgetSettings,
      previewHtml,
      customizeTemplate
    } = this.state;
    const enableCustomization =
      formValues && formValues.enableCustomization ? formValues.enableCustomization : false;
    const originCompiledTemplate = !_.isEmpty(codeEditTemplate.widgetTemplate)
      ? formatTemplate(templateBuilder(codeEditTemplate.widgetTemplate, widgetSettings, {}, true))
      : '';
    const title = 'Instant Template - Code Editor';
    const tabs = [
      {
        id: 'code-editor',
        content: `Code Editor ${
          codeEditTemplate.widgetName ? ` - ${codeEditTemplate.widgetName}` : ''
        }`,
        panelID: 'code-editor'
      },
      {
        id: 'preview',
        content: 'Preview',
        panelID: 'preview'
      },
      {
        id: 'settings',
        content: 'Settings',
        panelID: 'settings'
      },
      {
        id: 'compiled-template',
        content: 'Compiled Template',
        panelID: 'compiled-template'
      }
    ];
    const columnStyle = {
      flex: 1,
      height: '100%',
      border: '1px solid #ccc',
      boxSizing: 'border-box'
    };
    const { templateId } = this.props.match.params;
    console.log({ widgetSettings, selectedWidget, customizeTemplate });
    return (
      <div className="BC-Page BC-Page__ShopifyIntegration-CodeEditor">
        <FullscreenBar
          onAction={() => this.handleCloseFullscreenPage()}
          backTitle={i18n.translate('AdminHTML.Common.Action.exit')}
          title={title}
          actions={
            <ButtonGroup>
              {/* {isCreateFlow || hasSettings ? (
                <Button onClick={this.handlePrevious} disabled={saving || widgetCreating}>
                  {i18n.translate('AdminHTML.Common.Action.previous')}
                </Button>
              ) : (
                ''
              )} */}

              <Button
                primary
                onClick={() =>
                  this.props.updateTemplateInstancesWidgets(
                    templateId,
                    selectedWidget.filter(widget => widget.hasCustomized),
                    widgetSettings
                  )
                }
                // disabled={disabledNextStep}
                loading={updateTemplateInstancesLoading}>
                Save
              </Button>
            </ButtonGroup>
          }
          // progress={isCreateFlow ? (hasSettings ? 75 : 67) : -1}
        />

        {/* <MainMenu menuId="menu-theme-shopify-integration" /> */}
        <div className="BC-Widget-Editor-Page widget-visual-editor">
          <div className="visual-editor-body">
            {!_.isEmpty(selectedWidget) && (
              <SettingsHeading
                templates={selectedWidget}
                // currentSection={currentSection}
                updateCurrentSection={this.updateCurrentSection}
              />
            )}
            {!_.isEmpty(customizeTemplate) && (
              <div style={{ width: '100%', justifyContent: 'center' }}>
                <Tabs tabs={tabs} selected={selectedTabIndex} onSelect={this.handleTabChange}>
                  <Card.Section>
                    {selectedTabIndex === 0 ? (
                      <div style={{ display: 'flex' }}>
                        <div style={columnStyle}>
                          <div>
                            <span>Compile template</span>
                          </div>
                          <CodeEditor
                            language={'html'}
                            value={originCompiledTemplate}
                            options={{ readOnly: true }}
                            // onChange={value => this.onChangeCode(value)}
                          />
                        </div>
                        <div style={columnStyle}>
                          <div>
                            <Field
                              name="enableCustomization"
                              component={RenderToggleSwitch}
                              label={'Enable customize template'}
                              // helperText={i18n.translate(
                              //   'AdminHTML.Recommendation.GeneralSettings.CurrentlyView.toggleDescription'
                              // )}
                            />
                          </div>
                          <CodeEditor
                            language={'html'}
                            value={customizeTemplate}
                            onChange={value => this.onChangeCode(value)}
                            // options={{ readOnly: !enableCustomization }}
                            disabled={!enableCustomization}
                          />
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                    {selectedTabIndex === 1 ? (
                      <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
                    ) : (
                      ''
                    )}
                    {selectedTabIndex === 2 ? (
                      <CodeEditor
                        language={'json'}
                        value={JSON.stringify(widgetSettings, null, 2)}
                        onChange={value => this.onChangeSettings(value)}
                      />
                    ) : (
                      ''
                    )}

                    {selectedTabIndex === 3 ? (
                      <CodeEditor
                        language={'html'}
                        value={formatTemplate(previewHtml)}
                        onChange={() => {}}
                      />
                    ) : (
                      ''
                    )}
                  </Card.Section>
                </Tabs>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

// export default SsrCodeEditor;
const mapStateToProps = (state, props) => {
  const { templateInstance = {}, themeIntegration = {} } = state;
  console.log({ templateInstance, themeIntegration });
  // const themes = _.get(shopifyIntegrationTheme, 'allThemes', []);
  const instantWidget = _.get(templateInstance, 'templateInstance', {});
  const widgetSettings = _.get(themeIntegration, 'widgetSettings', {});
  const scssContent = _.get(themeIntegration, 'scssContent', '');
  const updateTemplateInstancesLoading = _.get(
    templateInstance,
    'updateTemplateInstancesLoading',
    false
  );
  // Theme integration setup
  const integratingTheme = _.get(themeIntegration, 'integratingTheme', false);
  // const createdTemplateInstance = _.get(themeIntegration, 'createdTemplateInstance', {});
  const formValues = getFormValues('SsrCodeEditorForm')(state);

  return {
    scssContent,
    widgetSettings,
    instantWidget,
    integratingTheme,
    formValues,
    updateTemplateInstancesLoading
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  getTemplateInstance: templateId =>
    dispatch(templateInstanceAction.getTemplateInstanceById(ownProps.i18n, templateId)),
  getThemeSettings: templateId =>
    dispatch(themeIntegrationAction.getThemeSettings(ownProps.i18n, templateId)),
  handleOpenFullscreen: isOpenFullScreen => dispatch(handleOpenFullscreen(isOpenFullScreen)),
  updateField: (field, value) => dispatch(change(`SsrCodeEditorForm`, field, value)),
  updateTemplateInstancesWidgets: (widgetId, widgets, settings) =>
    dispatch(
      templateInstanceAction.updateTemplateInstancesWidgets(
        ownProps.i18n,
        widgetId,
        widgets,
        settings
      )
    )
});
const SsrCodeEditorForm = reduxForm({
  form: 'SsrCodeEditorForm', // a unique identifier for this form
  enableReinitialize: true
})(SsrCodeEditor);

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(SsrCodeEditorForm));
